module.exports = __webpack_public_path__ + "img/WF.335c9775.png";